import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../redux/store';
import blackLogo from '../assets/img/black.log.png';
import { useForm } from 'react-hook-form';

import { forgotPass, clearState } from '../redux/users/slice';

import { usersSelector } from '../redux/users/selectors';

type FormData = {
  email: string;
};

const ForgotPassword = () => {
  const dispatch = useAppDispatch();

  const { isFetching } = useSelector(usersSelector);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const onSubmit = async (data: FormData) => {
    const email = data?.email?.trim();
    setError(null);
    setSuccess(false);
    dispatch(clearState());

    const response = await dispatch(forgotPass({ email }));
    if (forgotPass.fulfilled.match(response)) {
      setSuccess(true);
      reset();
      return;
    }

    const errorMsg =
      typeof response.payload === 'string'
        ? response.payload
        : 'Unable to process your request. Please try again.';
    setError(errorMsg);
  };

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  const name = {
    fontSize: '2.1rem',
  };
  const paragraph = {
    fontSize: '1.2rem',
  };

  const img = {
    width: '120px',
  };
  const invalid = {
    color: 'red',
  };

  return (
    <>
      <>
        <div className='des-bg'>
          {/*===== MW-banner-sec Start =======*/}
          <section className='MW-signpage'>
            <div className='container'>
              <div className='row'>
                <div className='Sign-bg'>
                  <form action='' onSubmit={handleSubmit(onSubmit)}>
                    <div className='Mw-Sign text-center'>
                      <img
                        style={img}
                        src={blackLogo}
                        className='img-fluid'
                        alt='MouseWait-logo'
                      />

                      <h3 style={name}>Forgot Password?</h3>
                      <p style={paragraph}>
                        Enter your email address to reset your password
                      </p>

                      {success ? (
                        <div className='alert alert-success'>
                          <p>Please Check Your Mail Box !</p>
                        </div>
                      ) : null}
                      {error ? (
                        <div className='alert alert-danger'>
                          <p>{error}</p>
                        </div>
                      ) : null}
                    </div>
                    <div className='sign-from'>
                      <div className='form-floating mb-3'>
                        <input
                          type='email'
                          className='form-control'
                          id='floatingInput'
                          placeholder='mw-email'
                          {...register('email', {
                            required: true,
                            pattern:
                              /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                          })}
                        />
                        <label htmlFor='floatingInput'>
                          <i className='fa-regular fa-envelope' />
                          Email
                        </label>
                        {errors.email && (
                          <span style={invalid}>Invalid email</span>
                        )}
                      </div>
                      <div className='form-floating'></div>
                    </div>
                    <div className='sign-btn text-center'>
                      <button
                        type='submit'
                        className='MW-btn'
                        disabled={isFetching}
                      >
                        {isFetching ? 'Sending...' : 'Send'}
                      </button>
                    </div>
                  </form>
                </div>
                <div></div>
              </div>
            </div>
          </section>
        </div>
      </>
    </>
  );
};

export default ForgotPassword;
